<template>
  <div class="home">
    <div class="one">
      <ban-Component class="ban"></ban-Component>
    </div>
    <div class="develop wow fadeInUp">
        <div class="line"></div>
        <div class="content">
         <div class="left">
             <img class="i1" src="../assets/tt.png" alt="">
             <img class="i2" src="../assets/yr/light.png" alt="">
             <p class="sm">{{$t('home').text3}}</p>
              <div class="btn" @click="goto(0)">
                  <btn-Component  :text="$t('btn')"></btn-Component>
              </div>
         </div>
            <div class="right">
                <img src="../assets/yr/right2.png" alt="">
            </div>
        </div>
    </div>

    <div class="service wow fadeInUp">
      <p class="title">{{$t('home').text4}}</p>
      <div class="lines">
        <span></span>
        <span class="t"></span>
        <span></span>
      </div>
      <div class="mainCon">
          <img class="img1" src="../assets/o3.png" alt="">
          <div class="rtext">
              <p>
                 <span> In-house manufacturing</span><br>
                  We have our factory for the customized lighting manufacturing process.<br>
                  <br>
              </p>
              <p>
                  <span> Customized lighting service</span><br>
                  We are proud of our lighting research & development capabilities and our flexibility to adapt your manufacturing requirement.<br>
                  <br>
              </p>
              <p>
                  <span> Stable quality</span><br>
                  We cooperate with powerful brands such as Philips and Mean Well, strict lighting control plans translate into dimensional layouts.
              </p>
          </div>
          <img class="img2" src="../assets/o1.png" alt="">
<!--     <div class="left1 a1" @click="big" :style="aStyle" :class="{'ac1':num===0}">-->
<!--       <img class="i" src="../assets/home/s/security.jpg" alt="">-->
<!--       <div class="text">-->
<!--         <img src="../assets/yr/left.png" alt="">-->
<!--         <p>-->
<!--             {{$t('home').text11[0]}}<br>-->
<!--             {{$t('home').text11[1]}}</p>-->
<!--       </div>-->
<!--       <div class="o animated fadeInDown" v-if="num===0">-->
<!--         <p>Precision Sheet Metal Processing(Security)</p>-->
<!--         <p class="a">High-power shearing machine, high-precision laser cutting machine imported from Germany,<br>-->
<!--           CNC punching machine, high-precision CNC bending machine,</p>-->
<!--         <div class="more" >-->
<!--           <btn-Component :text="$t('btn')"></btn-Component>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
<!--&lt;!&ndash;        <div class="center" :style="bStyle" @click="big3" :class="{'ac1':num===1}">&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="../assets/home/s/center.jpg" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="o animated fadeInDown" v-if="num===1">&ndash;&gt;-->
<!--&lt;!&ndash;          <p>Professional lamp production</p>&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="a">ur company is locates in Ningbo city of Zhejiang province. Since we established five years ago, the company has the face of fierce competition in the market. We always keep in mind the strict quality control.</p>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="more" >&ndash;&gt;-->
<!--&lt;!&ndash;                    <btn-Component :text="$t('btn')"></btn-Component>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--        <div class="left1 a2" @click="big2" :style="cStyle" :class="{'ac1':num===2}">-->
<!--          <img class="i" src="../assets/home/s/telecom.jpg" alt="">-->
<!--          <div class="text">-->
<!--            <img src="../assets/yr/r.png" alt="">-->
<!--            <p>-->
<!--                {{$t('home').text12[0]}}<br>-->
<!--                {{$t('home').text12[1]}}</p>-->
<!--          </div>-->
<!--          <div class="o animated fadeInDown" v-if="num===2">-->
<!--            <p>Precision Sheet Metal Processing(telecom)</p>-->
<!--            <p class="a">High-power shearing machine, high-precision laser cutting machine imported from Germany,<br>-->
<!--              CNC punching machine, high-precision CNC bending machine,</p>-->
<!--            <div class="more" >-->
<!--              <btn-Component :text="$t('btn')"></btn-Component>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

      </div>
    </div>

<!--      <div class="pro wow fadeInUp">-->
<!--          <p class="title">{{$t('home').text5}}</p>-->
<!--          <div class="lines">-->
<!--              <span></span>-->
<!--              <span class="t"></span>-->
<!--              <span></span>-->
<!--          </div>-->
<!--          <div class="proMain">-->
<!--              <el-carousel class="ma" trigger="click" height="450px" indicator-position="outside" :autoplay="autoplay">-->
<!--                  <el-carousel-item class="item" v-for="(item,index) in proList" :key="index">-->
<!--                     <div class="oneItem" v-for="(i,idx) in item.conList" :key="idx">-->
<!--                         <router-link :to="{path: 'proInfo',query:{id:i.ID}}" target="_blank">-->
<!--                             <img :src="`http://www.yourlonglighting.com/upload/${i.SMALLPIC}`" alt="">-->
<!--                         <p class="t1">{{i.PRONAME}}</p>-->
<!--                         <div class="last">-->
<!--                             <p>{{i.TITLE2}}</p>-->
<!--                             <i class="iconfont icon-youjiantou"></i>-->
<!--                         </div>-->
<!--                         </router-link>-->
<!--                     </div>-->
<!--                  </el-carousel-item>-->
<!--              </el-carousel>-->

<!--              <el-carousel class="mb" trigger="click" height="450px"  indicator-position="outside" :autoplay="autoplay">-->
<!--                  <el-carousel-item class="item" v-for="(item,index) in proList2" :key="index">-->
<!--                      <div class="oneItem" v-for="(i,idx) in item.conList" :key="idx">-->
<!--                          <router-link :to="{path: 'proInfo',query:{id:i.ID}}" target="_blank">-->
<!--                              <img :src="`http://www.yourlonglighting.com/upload/${i.SMALLPIC}`" alt="">-->
<!--                              <p class="t1">{{i.PRONAME}}</p>-->
<!--                              <div class="last">-->
<!--                                  <p>{{i.TITLE2}}</p>-->
<!--                                  <i class="iconfont icon-youjiantou"></i>-->
<!--                              </div>-->
<!--                          </router-link>-->
<!--                      </div>-->
<!--                  </el-carousel-item>-->
<!--              </el-carousel>-->
<!--          </div>-->
<!--      </div>-->

      <div class="blog wow fadeInUp">
          <p class="title">{{$t('home').text6}}</p>
          <div class="lines">
              <span></span>
              <span class="t"></span>
              <span></span>
          </div>
          <div class="mainCon">
              <div class="item" v-for="(item,index) in blogList" :key="index" :class="{'titem':index>0}">
                  <router-link :to="{path: 'blogInfo',query:{id:item.ID}}" target="_blank">
                      <img :src="`http://www.yourlonglighting.com/upload/${item.SMALLPIC}`" alt="">
                  <p class="t1">{{item.TITLE}}</p>
                  <p class="t2">{{item.ZY}}</p>
                  <p class="t3">{{$t('home').text10}}</p>
                  <div class="time">
                    <p>{{item.time2}}</p>
                      <p class="ti">{{item.SHOWTIME}}</p>
                  </div>
                  </router-link>
              </div>
          </div>
          <div style="text-align: center;padding-left: 2%;" @click="goto(5)">
              <btn-Component :text="$t('btn')"></btn-Component>
          </div>
      </div>

    <foot-Component></foot-Component>
  </div>
</template>

<script>
import  banComponent from '../components/banner'
import footComponent from '../components/foot'
import btnComponent from '../components/btn'
import { getNewsUrl,getProductsUrl} from '../util/lang'
export default {
  name: 'home',
  data(){
    return{
      num:1,
        autoplay:false,
      aStyle:{},
      bStyle:{},
      cStyle:{},
        proList:[],
        blogList:[],
        proList2:[]
    }
  },
  components:{
    banComponent,footComponent,btnComponent},
    mounted(){
        localStorage.setItem('index','0')
        if(this.$i18n.locale==='en'){
            this.getNews('38')
            this.getTj2('72')
        }else{
            this.getNews('40')
            this.getTj2('84')
        }

    },
  methods:{
      getTj2(id){
          const url = `${getProductsUrl(this.$i18n.locale,id,100,1)}`
          let list=[]
          this.$axios.get(url).then(res => {
              res.data.proarr.map((item)=>{
                  if(item.ISCOMMEND==='1')
                     list.push(item)
              })
              for(let i=0;i<list.length;i+=3){
                  this.proList.push({conList:list.slice(i,i+3)})
              }
              for(let i=0;i<list.length;i+=1){
                  this.proList2.push({conList:list.slice(i,i+1)})
              }
          })
      },
      getNews(id){
          const url = `${getNewsUrl(this.$i18n.locale,id,100,1)}`
          this.$axios.get(url).then(res => {
              res.data.newsArr.map((item)=>{
                  item.time2=item.SHOWTIME.substring(8,10)
                  item.SHOWTIME=item.SHOWTIME.substring(0,7)
                  if(item.ISCOMMEND==='1')
                      this.blogList.push(item)
              })
          })
      },
      goto(n){
          if(n===0){
              this.$router.push({path:'/about'})
          }else if(n===5){
              this.$router.push({path:'/news'})
          }
      },
    big(){
      this.num=0
      // this.aStyle={width:'60%'}
      // this.bStyle={width:'20%'}
      // this.cStyle={width:'50%'}
    },
    big2(){
      this.num=2
      // this.aStyle={width:'20%'}
      // this.bStyle={width:'20%'}
      // this.cStyle={width:'60%'}
    },
    big3(){
      this.num=1
      this.aStyle={width:'20%'}
      this.bStyle={width:'60%'}
      this.cStyle={width:'20%'}
    }
  }
}
</script>
<style lang="scss" scoped>
  .home{
    width:100%;
      animation: down 2s linear;
      @keyframes down {
          from{
              transform: translateX(-30px);
          }
          to{
              transform: translateX(0);
          }
      }
    .one{
      width:100%;
      position: relative;
      height:100vh;
      .ban{
        width:100%;
        position: absolute;
        left:0;
        top:0;
        height:100%;
        z-index: 100;
      }
    }
    .develop{
       width:100%;
        position: relative;
        padding: 60px 0;
        .line{
            position: absolute;
            left:0;
            top:100px;
            height:1px;
            width:25%;
            background-color: #EFEFEF;
        }
        .content{
            width:1280px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            .left{
                width:50%;
                padding-top: 70px;
                p:nth-child(1){
                    font-size: 65px;
                    text-indent: 5%;
                  font-family:Calibri;
                    font-style: italic;
                    margin-block-end: 0;
                }
                p:nth-child(2){
                    color:#F4A000;
                    font-size: 45px;
                    font-style: italic;
                    font-family: Calibri;
                    margin-block-start: 0;
                    text-indent: 26%;
                    font-weight: bold;
                    margin-block-end: 10px;
                }
                .i1{
                    margin-left:5%;
                }
                .i2{
                    margin-left: 30%;
                    margin-top: 10px;
                }
                .sm{
                    color:#828282;
                   font-family:Calibri;
                    font-weight: lighter;
                    line-height: 30px;
                    text-align: center;
                    width:80%;
                    margin-left: 5%;
                }
                .btn{
                    text-align: center;
                    width:90%;
                    margin-top: 30px;
                }
            }
            .right{
                width:48%;
                margin-left: 2%;
                padding-top: 180px;
                overflow: hidden;
                img{
                    width:100%;
                    cursor: pointer;
                    transition: all 2s;
                }
                img:hover{
                    transform: scale(1.05);
                }
            }
        }
    }
    .service{
      width:100%;
      margin-top: 60px;
      .title{
        text-align: center;
        text-transform: uppercase;
        font-family:Calibri;
        font-size: 35px;
        margin-block-end: 0.5em;
      }
      .lines{
        width:100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
          display: inline-block;
          width:15px;
          height:1px;
          background-color: rgba(0,0,0,.6);
          margin-top:5px;
        }
        .t{
          width:11px;
          background-color: rgba(0,0,0,.3);
        }
      }
      .mainCon{
        width:100%;
        display: flex;
        flex-direction: row;
        margin-top: 60px;
          position: relative;
          .img1{
              width:100%;
              object-fit: cover;
              height:600px;
          }
          .rtext{
              position: absolute;
              right:0;
              top:0;
              width:60%;
              height:100%;
              background: url("../assets/o2.png") no-repeat;
              background-size: cover;

              p{
                  color:white;
                  width:50%;
                  margin-left: 40%;
                  line-height: 30px;
                  color:rgba(255,255,255,.8);
                  position: relative;
                  span{
                      font-size: 25px;
                      color:white;
                      text-transform: capitalize;
                      padding-left: 10px;
                  }
              }
              p:nth-child(1){
                  margin-top: 8%;
              }
              p::after{
                  content:'';
                  display: inline-block;
                  position: absolute;
                  left:-50px;
                  top:15px;
                  width:40px;
                  height:2px;
                  background-color: #997A16;
              }
          }
          .img2{
              position: absolute;
              left:18%;
             bottom:0;
              height:90%;
              object-fit: cover;
              width:40%;
          }
        img{
          display: block;
        }
        .left1{
          width:50%;
          height:100%;
          position: relative;
          cursor: pointer;
          transition: all 600ms;
          .i{
            width:100%;
            height:100%;
            object-fit: cover;
          }
          .text{
            position: absolute;
            left:0;
            top:35%;
            width:100%;
            text-align: center;
            text-transform: uppercase;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family:Calibri;
            font-size: 25px;
            color:white;
          }
          .o{
            position: absolute;
            left:10%;
            width:60%;
            bottom:8%;
            height:300px;
            background-color: rgba(0,0,0,.6);
            color:white;
            text-align: center;
            padding: 0 10%;
            p:first-child{
              font-family:Calibri;
              font-size: 30px;
            }
            .a{
              font-family:Calibri;
              font-weight: lighter;
              font-size: 14px;
              line-height: 40px;
            }
            .more{
              margin-top: 30px;
            }
          }
        }
        .center{
          width:60%;
          height:100%;
          position: relative;
          transition: all 600ms;
          cursor: pointer;
          img{
            width:100%;
            height:100%;
            object-fit: cover;
          }
          .o{
            position: absolute;
            left:10%;
            width:60%;
            bottom:10%;
            height:300px;
            background-color: rgba(0,0,0,.6);
            color:white;
            text-align: center;
            padding: 0 10%;
            p:first-child{
              font-family:Calibri;
              font-size: 30px;
            }
           .a{
              font-family:Calibri;
              font-weight: lighter;
             font-size: 14px;
             line-height: 40px;
            }
            .more{
              margin-top: 30px;
            }
          }
        }
          .a1::before{
              position: absolute;
              left:0;
              top:0;
              width:100%;
              height:100%;
              background-color: rgba(0,0,0,.8);
              content:'';
              display: inline-block;
              opacity: 1;
          }
          .a2::before{
              position: absolute;
              left:0;
              top:0;
              width:100%;
              height:100%;
              background-color: rgba(0,0,0,.8);
              content:'';
              display: inline-block;
              opacity: 1;
          }
          .center::before{
              position: absolute;
              left:0;
              top:0;
              width:100%;
              height:100%;
              background-color: rgba(0,0,0,.8);
              content:'';
              display: inline-block;
              opacity: 1;
          }
          .ac1::before{
            opacity: 0;
          }
          .a1{
              position: absolute;
              left:0;
              top:0;
              width:60%;
              height:100%;
              background-color: white;
              z-index: 100;
          }
          .a2{
              position: absolute;
              right:0;
              top:0;
              width:50%;
              height:100%;
              .text{
                  left:10%;
              }
              .o{
                  left:25%;
                  width:50%;
              }
          }
      }
    }
      .pro{
          width:100%;
          background-color: #F4F4F4;
          padding: 60px 0;
          .title{
          text-align: center;
          text-transform: uppercase;
          font-family:Calibri;
          font-size: 30px;
          margin-block-end: 0.5em;
              margin-block-start: 0;
      }
          .lines{
              width:100%;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              span{
                  display: inline-block;
                  width:15px;
                  height:1px;
                  background-color: rgba(0,0,0,.6);
                  margin-top:5px;
              }
              .t{
                  width:11px;
                  background-color: rgba(0,0,0,.3);
              }
          }
          .proMain{
              width:1280px;
              margin: 60px auto;
              .mb{
                  display: none;
              }
              .ma{
                  display: block;
              }
              .item{
                  width:100%;
                  display: flex;
                  flex-direction: row;
                  .oneItem{
                      width:30%;
                      background-color: white;
                      margin-left: 2.5%;
                      text-align: center;
                      cursor: pointer;
                      transition: all 1s;
                      a{
                          display: inline-block;
                          width:100%;
                      }
                      img{
                          width:100%;
                          height:340px;
                          object-fit: cover;
                      }
                      p{
                          text-align: left;
                          width:80%;
                          margin-left: 10%;
                          font-family:Calibri;
                          text-transform: uppercase;
                      }
                      .t1{
                          font-size: 22px;
                          margin-block-end: 0;
                          transition: all 2s;
                          display: -webkit-box;
                          height:30px;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 1;
                          overflow: hidden;
                          font-family: Calibri;
                      }
                      .last{
                          width:80%;
                          margin-left: 10%;
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          i{
                              color:#696969;
                              font-size: 20px;
                              transition: all 2s;
                              line-height: 30px;
                          }
                          p{
                              margin-block-start: 0.5em;
                              margin-left: 0;
                              color:#696969;
                          }
                      }
                  }
                  .oneItem:hover{
                      box-shadow:5px 5px 5px 5px #e2e2e2;
                      .t1{
                          color:#F4A000;
                      }
                      .last{
                          i{
                              color:#F4A000;
                          }
                      }
                  }
              }
          }
      }
      .blog{
          width:100%;
          padding: 60px 0;
          .title{
              text-align: center;
              text-transform: uppercase;
              font-family: Calibri;
              font-size: 30px;
              margin-block-end: 0.5em;
              margin-block-start: 0;
          }
          .lines{
              width:100%;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              span{
                  display: inline-block;
                  width:15px;
                  height:1px;
                  background-color: rgba(0,0,0,.6);
                  margin-top:5px;
              }
              .t{
                  width:11px;
                  background-color: rgba(0,0,0,.3);
              }
          }
          .mainCon{
              width:1280px;
              margin: 60px auto;
              display: flex;
              flex-direction: row;
              justify-content: center;
              .item{
                  background-color: #FAFAFA;
                  position: relative;
                  cursor: pointer;
                  transition: all 600ms;
                  width:30%;
                  img{
                      width:100%;
                  }
                  a{
                      color:black;
                  }
                  p{
                      width:90%;
                      margin-left: 5%;
                  }
                  .t1{
                      font-family: Calibri;
                      font-size: 20px;
                      transition: all 600ms;
                  }
                  .t2{
                      font-family:Calibri;
                      font-weight: lighter;
                      font-size: 14px;
                      line-height: 30px;
                      text-transform: capitalize;
                  }
                  .t3{
                      text-align: right;
                      font-family: Calibri;
                      font-size: 18px;
                      text-transform: uppercase;
                      transition: all 600ms;
                  }
                  .time{
                      position: absolute;
                      top:0;
                      width:20%;
                      left:10%;
                      display: flex;
                      flex-direction: column;
                      background-color: rgba(0,0,0,.8);
                      color:white;
                      font-family:Calibri;
                      font-size: 30px;
                      padding: 10px 0;
                      p{
                          margin-block-start: 0;
                          margin-block-end: 0;
                          text-align: center;
                      }
                      .ti{
                          font-size: 20px;
                      }
                  }
              }
              .item:hover{
                  transform:translateY(-20px);
                  .t1,.t3{
                      color:#F4A000;
                  }
              }
              .titem{
                  margin-left: 1%;
              }
          }
      }
      @media screen and (max-width:1440px){
     .service{
         .mainCon{
             .img1{
                 height:500px;
             }
             .rtext{
                 width:65%;
                 p{
                     margin-left: 45%;
                 }
             }
             .img2{
                 left:15%;
             }
         }
     }
      }
      @media screen and (max-width:450px){
          .aa{
              margin-left: 5%;
          }
          overflow: hidden;
          .develop{
              width:100%;
              .line{
                  width:50%;
              }
              .content{
                  width:95%;
                  flex-direction: column;
                  .left{
                      width:100%;
                      .i1{
                          width:100%;
                          object-fit: cover;
                          margin-left: 0;
                      }
                  }
                  .right{
                      width:100%;
                      padding-top: 20px;
                      margin-left: 0;
                  }
              }
          }
          .service{
              .mainCon{
                  .img1{
                      height:500px;
                  }
                  .rtext{
                      width:100%;
                      p{
                          margin-left: 5%;
                          width:90%;
                          text-align: center;
                          text-shadow: 2px 2px 6px rgba(0,0,0,.8);
                      }
                      p::after{
                          left: -10px;
                      }
                  }
                  .img2{
                      display: none;
                  }
              }
          }
          .pro{
              .proMain{
                  width:100%;
                  .ma{
                      display: none;
                  }
                  .mb{
                      display: block;
                  }
                  .item{
                      width:95%;
                      margin-left: 2.5%;
                      .oneItem{
                          width:100%;
                          margin-left: 0;
                          a{
                              width:100%;
                          }
                          img{
                              width:100%;
                              object-fit: cover;
                          }
                      }
                  }
              }
          }
          .blog{
              .mainCon{
                  width:90%;
                  margin-left: 5%;
                  flex-direction: column;
                  .item{
                      width:100%;
                      margin-left: 0;
                      margin-top: 40px;
                  }
              }
          }
      }
  }
</style>
